import * as Yup from 'yup';

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const addPropertySchema = Yup.object().shape({
  propertyTypeId: Yup.string()
    .required('Property Type required'),
  propertySharedId: Yup.string()
    .required('property Shared Type required'),
  location: Yup.string()
    .required('Location required'),
  phoneNumber: Yup.string()
    .matches(phoneRegExp, 'Phone number is not valid')
    .max(10, 'Phone number is too long - should be maximum 10 digits.')
    .required('Phone number required'),
  password: Yup.string()
    .required('Password is required')
    .matches(/\b([A-Z])/g, 'Password requires first letter Capital')
    .max(18, 'Password is too long - should be maximum 20 chars.')
    .min(7, 'Password is too short - should be 8 chars minimum.')
    .matches(/[0-9]/, 'Password requires a number')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[^\w]/, 'Password requires a special chars'),
  confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Password and confirm password does not match').required('Confirm password is required'),
  tos: Yup.bool().oneOf([true], 'You need to accept the terms and conditions'),
});

export const CencelBookingSchema = Yup.object().shape({
  cancellationReason: Yup.string()
    .required('Reason required'),
    bankName: Yup.string()
    .required('Bank name required'),
    bankAddress: Yup.string()
    .required('Bank address required'),
    bankAccountName: Yup.string()
    .required('Bank account Holder name required'),
    accountNumber: Yup.string()
    .required('Account number required'),
    swiftCode: Yup.string()
    .required('Swift code required')
});

export const FeedbackBookingSchema = Yup.object().shape({
  feedback: Yup.string()
    .required('Feedback required')
});